/**
 * Sentry beforeSend filter for known noisy browser errors.
 * Returns true to send the event, false to drop it.
 *
 * Note: ResizeObserver loop errors are filtered via ignoreErrors in Sentry.init()
 */

function getExceptionInfo(event) {
  const exception = event?.exception?.values?.[0];
  return {
    type: exception?.type,
    value: exception?.value,
  };
}

function isSecurityErrorWithRemoveEventListener(event) {
  const { type: exceptionType, value: exceptionValue } = getExceptionInfo(event);
  const combined = [exceptionType, exceptionValue, event?.message]
    .filter(Boolean)
    .join(' | ');
  const isSecurityError = exceptionType === 'SecurityError' || /^SecurityError\b/i.test(combined);
  const mentionsRemoveEventListener = /removeEventListener/i.test(combined);

  return isSecurityError && mentionsRemoveEventListener;
}

// REACT-GZV: Drop cross-origin SecurityError removeEventListener noise from third-party iframes
export function shouldSendSentryEvent(event) {
  return !isSecurityErrorWithRemoveEventListener(event);
}
